import { updateProfile } from '@/js/api/account.ts';
import { clearPhone } from '@/js/helper/clear-phone.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';

const SUCCESS_REQUEST_TEXT = 'Ваша учетная запись была успешно обновлена!';
export function initProfileUpdateForm(): void {
  const form = document.querySelector<HTMLFormElement>('.js-form-profile-update');
  if (!form) {
    return;
  }

  form.addEventListener('submit', handleFormSubmit);

  function handleFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    void formAsync(form);
  }

  async function formAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);

    const phone = formData.get('phone') ?? '';
    if (typeof phone === 'string') {
      formData.set('phone', clearPhone(phone));
    }

    try {
      const response = await updateProfile(formData);
      if (response.data?.success) {
        showSuccessNotify({ text: SUCCESS_REQUEST_TEXT });
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error: unknown) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
